module.exports = __webpack_public_path__ + "static/choose-workflow-11e8845dc5b8e21b79b01fb6e5b803d0.png";